// Annuaire vitrine des partenaires — structure extensible.
// Pour ajouter un partenaire : ajouter un objet dans `partners` du métier concerné.
// Pour ajouter un métier : ajouter un objet dans METIERS (la page /partenaires/:slug,
// le hub, le fil d'Ariane et le garde-fou SEO suivent automatiquement — penser juste
// à ajouter la route dans pageMeta.json et le sitemap).

export const METIERS = [
  {
    slug: "ferronnerie",
    name: "Ferronnerie",
    title: "Nos partenaires en ferronnerie",
    lead: "Le fer forgé donne aux sculptures leur ossature et leur présence. Voici les ateliers de ferronnerie d'art avec lesquels nous collaborons.",
    materiauxSlug: "metal",
    partners: [
      {
        id: "art-de-forge",
        detailPage: true,
        name: "Jérôme Mazoyer — Art de Forge",
        role: "Ferronnier d'art, Valréas (Vaucluse)",
        city: "Valréas (Vaucluse)",
        blurb:
          "Ferronnier d'art installé à Valréas, il forge des pièces métalliques sur mesure — sculpture, mobilier, ouvrages d'architecture — avec la rigueur de la forge traditionnelle.",
        logoCard: {
          src: "/images/ferronnerie-logo.webp",
          alt: "Arbre sculptural en métal forgé, atelier Art de Forge",
        },
        contact: {
          company: "Art de Forge SARL",
          addressLines: ["Z.I. de la Grèze — Allée Germain Aubert", "84600 Valréas"],
          tel: "06 80 70 14 56",
          telHref: "+33680701456",
          email: "art-de-forge@orange.fr",
        },
      },
    ],
  },
  {
    slug: "resine",
    name: "Résine",
    title: "Nos partenaires en résine",
    lead: "Polyester, moules, tirage, patine, : les artisans qui donnent vie à une sculpture.",
    materiauxSlug: "resine",
    partners: [
      {
        id: "petite-barat-polyester",
        detailPage: true,
        name: "Petit-Barat Polyester",
        role: "Atelier de polyester, Montaigut-en-Combraille (Puy-de-Dôme)",
        city: "Montaigut-en-Combraille 63700",
        blurb: "Atelier de polyester à Montaigut-en-Combraille : moules en résine et silicone, tirages en séries limitées, pour artistes et sculpteurs.",
        logoCard: {
          src: "/images/petitbarat-logo.webp",
          alt: "Logo Petit-Barat Polyester, atelier de moulage d'art contemporain",
        },
        contact: {
          company: "Petit-Barat Polyester",
          addressLines: ["Puy Gilard, 63700 Montaigut-en-Combraille"],
          tel: "06 10 53 86 01",
          telHref: "+33610538601",
          email: "petit.barat@laposte.net",
          site: "https://petitbaratpolyester.com/",
        },
      },
      {
        id: "evoludis-concept",
        detailPage: true,
        name: "Antoine Odent — Evoludis Concept",
        role: "Fabrication résine, Vila Nova de Famalicão (Portugal)",
        city: "Vila Nova de Famalicão (Portugal)",
        blurb:
          "Spécialiste du moulage et du tirage en résine, il réalise séries et finitions peintes pour des sculpteurs et des professionnels, de l'atelier portugais à l'œuvre.",
        logoCard: {
          src: "/images/evoludis-logo.webp",
          alt: "Sculpture cavalier d'échecs en résine, Evoludis Concept",
        },
        contact: {
          company: "Evoludis Concept",
          addressLines: ["Rua do Senhor dos Perdões, nº14", "4760-727 Ribeirão — Vila Nova de Famalicão, Portugal"],
          tel: "+351 925 160 794",
          telHref: "+351925160794",
          email: "antoine.odent@evoludis.pt",
        },
      },
    ],
  },
  {
    slug: "fonderie-art",
    name: "Fondeur d’art",
    title: "Nos partenaires en fonderie d’art",
    lead: "Bronze, moules, coulage, patine, coulage : les artisans qui donnent sa puissance à une sculpture.",
    materiauxSlug: "bronze",
    partners: [
      {
        id: "fonderie-du-peroux",
        detailPage: true,
        name: "Fonderie du Péroux",
        role: "Fonderie d’art, Vonnas (Ain)",
        city: "Vonnas 01540",
        blurb: "Fonderie d’art à Vonnas : fonte à la cire perdue et au sable, bronze, laiton et aluminium, pour les artistes et sculpteurs.",
        logoCard: {
          src: "/images/fdp-vague.webp",
          alt: "sculpture bronze fonderie du Péroux",
        },
        contact: {
          company: "Fonderie du Péroux",
          addressLines: ["2075 Rte de Péroux, 01290 Biziat"],
          tel: "06 32 79 71 56",
          telHref: "+33632797156",
          email: "fonderieduperoux@gmail.com",
        },
      },
    ],
  },
  {
    slug: "finitions",
    name: "Finitions et décors de surface",
    title: "Nos partenaires en finitions et décors de surface",
    lead: "Peinture, patine, vernis, décor par transfert : les artisans qui donnent sa surface finale à une sculpture.",
    partners: [
      {
        id: "hydrographie-concept",
        detailPage: true,
        name: "Hydrographie Concept",
        role: "Atelier d'hydrographie (impression hydrographique)",
        city: "Saint-Just-Saint-Rambert (Loire)",
        blurb:
          "Hydrographie peinture et impression hydrographique sur tous supports : environ 6 000 motifs, projets uniques et sur mesure, pour particuliers et professionnels.",
        logoCard: {
          src: "/images/hydrographie-concept-logo.webp",
          alt: "Logo Hydrographie Concept",
        },
        contact: {
          company: "Hydrographie Concept",
          addressLines: ["Saint-Just-Saint-Rambert (Loire)"],
        },
      },
    ],
  },
];

// Métier d'art associé à chaque fiche matériau (pour l'encadré « Artisans partenaires »,
// état vide : « Vous êtes fondeur d'art ? » etc.)
export const TRADE_BY_MATERIAL = {
  bronze: "fondeur d'art",
  resine: "fabricant de résine",
  platre: "mouleur",
  metal: "ferronnier d'art",
  bois: "sculpteur sur bois",
  pierre: "tailleur de pierre",
  terre: "céramiste ou potier",
};

// Partenaires correspondant à une fiche matériau (via materiauxSlug du métier)
export const partnersForMaterial = (materialSlug) =>
  METIERS.filter((m) => m.materiauxSlug === materialSlug).flatMap((m) =>
    m.partners.map((p) => ({ ...p, metierSlug: m.slug, metierName: m.name }))
  );
